/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PropostaResponse } from '../models/proposta-response';
import { Acordo } from '../models/acordo';
import { AcordoPaginado } from '../models/acordo-paginado';
import { DadosCalculoDivida } from '../models/dados-calculo-divida';
import { RequestCancelamentoPropostaType } from '../models/request-cancelamento-proposta-type';
import { RequestAprovacaoPropostaType } from '../models/request-aprovacao-proposta-type';
import { RequestReprocessarBoletoType } from '../models/request-reprocessar-boleto-type';

/**
 * Fase inicial de um acordo, podendo ou nao ser efetivada como um acordo.
 */
@Injectable({
  providedIn: 'root',
})
class PropostaService extends __BaseService {
  static readonly salvarPropostaPath = '/propostas';
  static readonly alterarPropostaPath = '/propostas';
  static readonly obterProcessoRessarcimentoPath = '/propostas';
  static readonly calcularDividaPath = '/propostas/calcularDivida';
  static readonly obterHonorariosPath = '/propostas/obterHonorarios';
  static readonly cancelarPropostaPath = '/propostas/reprovar-proposta';
  static readonly aprovarPropostaPath = '/propostas/aprovar-proposta';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Cadastra uma Proposta
   * @param acordo Objeto do acordo
   * @return Operacao realizada com sucesso
   */
  salvarPropostaResponse(acordo: Acordo): __Observable<__StrictHttpResponse<PropostaResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/propostas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PropostaResponse>;
      })
    );
  }
  /**
   * Cadastra uma Proposta
   * @param acordo Objeto do acordo
   * @return Operacao realizada com sucesso
   */
  salvarProposta(acordo: Acordo): __Observable<PropostaResponse> {
    return this.salvarPropostaResponse(acordo).pipe(
      __map(_r => _r.body as PropostaResponse)
    );
  }

  /**
   * Altera os dados de uma Proposta
   * @param acordo Objeto do acordo
   */
  alterarPropostaResponse(acordo: Acordo): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/propostas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Altera os dados de uma Proposta
   * @param acordo Objeto do acordo
   */
  alterarProposta(acordo: Acordo): __Observable<null> {
    return this.alterarPropostaResponse(acordo).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Recupera uma proposta ou acordo a partir do seu sistema de origem
   * @param params The `PropostaService.ObterProcessoRessarcimentoParams` containing the following parameters:
   *
   * - `sistemaOrigem`: Data inicial da pesquisa
   *
   * - `sequenciaItemSinistro`: Numero sequencial do item do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterProcessoRessarcimentoResponse(params: PropostaService.ObterProcessoRessarcimentoParams): __Observable<__StrictHttpResponse<AcordoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sistemaOrigem != null) __params = __params.set('sistemaOrigem', params.sistemaOrigem.toString());
    if (params.sequenciaItemSinistro != null) __params = __params.set('sequenciaItemSinistro', params.sequenciaItemSinistro.toString());
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.numeroSinistro != null) __params = __params.set('numeroSinistro', params.numeroSinistro.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/propostas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcordoPaginado>;
      })
    );
  }
  /**
   * Recupera uma proposta ou acordo a partir do seu sistema de origem
   * @param params The `PropostaService.ObterProcessoRessarcimentoParams` containing the following parameters:
   *
   * - `sistemaOrigem`: Data inicial da pesquisa
   *
   * - `sequenciaItemSinistro`: Numero sequencial do item do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Ano do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterProcessoRessarcimento(params: PropostaService.ObterProcessoRessarcimentoParams): __Observable<AcordoPaginado> {
    return this.obterProcessoRessarcimentoResponse(params).pipe(
      __map(_r => _r.body as AcordoPaginado)
    );
  }

  /**
   * Calcula os valores da divida
   * @param dadosCalculoDivida Objeto com os dados da divida
   * @return Calculo realizado com sucesso
   */
  calcularDividaResponse(dadosCalculoDivida: DadosCalculoDivida): __Observable<__StrictHttpResponse<DadosCalculoDivida>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dadosCalculoDivida;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/propostas/calcularDivida`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DadosCalculoDivida>;
      })
    );
  }
  /**
   * Calcula os valores da divida
   * @param dadosCalculoDivida Objeto com os dados da divida
   * @return Calculo realizado com sucesso
   */
  calcularDivida(dadosCalculoDivida: DadosCalculoDivida): __Observable<DadosCalculoDivida> {
    return this.calcularDividaResponse(dadosCalculoDivida).pipe(
      __map(_r => _r.body as DadosCalculoDivida)
    );
  }

  /**
   * Retorna o percentual de honorarios
   * @param acordo Objeto com os dados do acordo
   * @return Recuperacao dos honorarios realizado com sucesso
   */
  obterHonorariosResponse(acordo: Acordo): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/propostas/obterHonorarios`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: parseFloat((_r as HttpResponse<any>).body as string) }) as __StrictHttpResponse<number>
      })
    );
  }
  /**
   * Retorna o percentual de honorarios
   * @param acordo Objeto com os dados do acordo
   * @return Recuperacao dos honorarios realizado com sucesso
   */
  obterHonorarios(acordo: Acordo): __Observable<number> {
    return this.obterHonorariosResponse(acordo).pipe(
      __map(_r => _r.body as number)
    );
  }

  /**
   * Cancela uma proposta
   *
   * Efetua o cancelamento de uma proposta
   * @param requestCancelamentoProposta Informacoes da proposta a ser cancelada
   */
  cancelarPropostaResponse(requestCancelamentoProposta: RequestCancelamentoPropostaType): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestCancelamentoProposta;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/propostas/reprovar-proposta`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Cancela uma proposta
   *
   * Efetua o cancelamento de uma proposta
   * @param requestCancelamentoProposta Informacoes da proposta a ser cancelada
   */
  cancelarProposta(requestCancelamentoProposta: RequestCancelamentoPropostaType): __Observable<null> {
    return this.cancelarPropostaResponse(requestCancelamentoProposta).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Aprova uma proposta
   *
   * Efetua a aprovacao de uma proposta
   * @param RequestAprovacaoPropostaType Informacoes da proposta a ser aprovada
   */
  aprovarPropostaResponse(RequestAprovacaoPropostaType: RequestAprovacaoPropostaType): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestAprovacaoPropostaType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/propostas/aprovar-proposta`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Aprova uma proposta
   *
   * Efetua a aprovacao de uma proposta
   * @param RequestAprovacaoPropostaType Informacoes da proposta a ser aprovada
   */
  aprovarProposta(RequestAprovacaoPropostaType: RequestAprovacaoPropostaType): __Observable<null> {
    return this.aprovarPropostaResponse(RequestAprovacaoPropostaType).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Reprocessar boleto acordo
   *
   * Efetua o reprocessar o envio de boleto de um acordo
   * @param requestReprocessarBoleto Informacoes do acordo a ser reprocessado
   */
reprocessarBoletoAcordoResponse(requestReprocessarBoleto: RequestReprocessarBoletoType): __Observable<__StrictHttpResponse<null>> {
  let __params = this.newParams();
  let __headers = new HttpHeaders();
  let __body: any = null;
  __body = requestReprocessarBoleto;
  let req = new HttpRequest<any>(
    'POST',
    this.rootUrl + `/propostas/envio-boleto`,
    __body,
    {
      headers: __headers,
      params: __params,
      responseType: 'json'
    });

  return this.http.request<any>(req).pipe(
    __filter(_r => _r instanceof HttpResponse),
    __map((_r) => {
      return _r as __StrictHttpResponse<null>;
    })
  );
}
/**
 * Reprocessar boleto acordo
 *
 * Efetua o reprocessar o envio de boleto de um acordo
 * @param requestReprocessarBoleto Informacoes do acordo a ser reprocessado
 */
reprocessarBoletoAcordo(requestReprocessarBoleto: RequestReprocessarBoletoType): __Observable<null> {
  return this.reprocessarBoletoAcordoResponse(requestReprocessarBoleto).pipe(
    __map(_r => _r.body as null)
  );
}

}

module PropostaService {

  /**
   * Parameters for obterProcessoRessarcimento
   */
  export interface ObterProcessoRessarcimentoParams {

    /**
     * Data inicial da pesquisa
     */
    sistemaOrigem?: number;

    /**
     * Numero sequencial do item do sinistro
     */
    sequenciaItemSinistro?: number;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Numero do sinistro
     */
    numeroSinistro?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Ano do sinistro
     */
    anoSinistro?: number;
  }
}

export { PropostaService }
